import { SerializedFarm } from 'state/types'
import { fetchHolderBonusPools } from 'state/farms/utils'
import { addressesEqual } from 'utils/addressHelpers'

const fetchFarmsBonuses = async (farms: SerializedFarm[]) => {
  const holderBonusPools = await fetchHolderBonusPools()

  return farms.map((farm) => {
    const holderBonusForFarm = holderBonusPools.find(({ farmAddress }) =>
      addressesEqual(farm.stakingServiceAddress, farmAddress),
    )

    return {
      ...farm,
      ...(!!holderBonusForFarm && {
        holderBonusPool: {
          effectivePoolSizeInLpTokens: holderBonusForFarm.effectivePoolSizeInLpTokens,
          dailyPoolSizeNmx: holderBonusForFarm.dailyPoolSizeNmx,
        },
      }),
    }
  })
}

export default fetchFarmsBonuses
